'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164 from "./presto.types$-Two-Factor-Auth-Name$$anon$164.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165 from "./presto.types$-Two-Factor-Auth-Name$$anon$165.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthName$() {
  this.cbD = null;
  this.cbE = false;
  this.cbB = null;
  this.cbC = false;
  this.cbH = null;
  this.cbI = false;
  this.cbF = null;
  this.cbG = false;
  this.cbJ = null;
  this.cbK = false;
}
export { $c_Lpresto_types$TwoFactorAuthName$ as $c_Lpresto_types$TwoFactorAuthName$ };
$p = $c_Lpresto_types$TwoFactorAuthName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthName$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthName$() {
}
export { $h_Lpresto_types$TwoFactorAuthName$ as $h_Lpresto_types$TwoFactorAuthName$ };
$h_Lpresto_types$TwoFactorAuthName$.prototype = $p;
$p.cHS = (function() {
  if ((!this.cbE)) {
    this.cbD = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cbE = true;
  }
  return this.cbD;
});
$p.zh = (function() {
  if ((!this.cbC)) {
    this.cbB = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8;
    this.cbC = true;
  }
  return this.cbB;
});
$p.a2w = (function() {
  if ((!this.cbI)) {
    this.cbH = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cbI = true;
  }
  return this.cbH;
});
$p.crL = (function() {
  if ((!this.cbG)) {
    this.cbF = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164.$c_Lpresto_types$TwoFactorAuthName$$anon$164(this);
    this.cbG = true;
  }
  return this.cbF;
});
$p.a2D = (function() {
  if ((!this.cbK)) {
    this.cbJ = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165.$c_Lpresto_types$TwoFactorAuthName$$anon$165(this);
    this.cbK = true;
  }
  return this.cbJ;
});
var $d_Lpresto_types$TwoFactorAuthName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthName$, "presto.types$TwoFactorAuthName$", ({
  a2E: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthName$ as $d_Lpresto_types$TwoFactorAuthName$ };
var $n_Lpresto_types$TwoFactorAuthName$;
function $m_Lpresto_types$TwoFactorAuthName$() {
  if ((!$n_Lpresto_types$TwoFactorAuthName$)) {
    $n_Lpresto_types$TwoFactorAuthName$ = new $c_Lpresto_types$TwoFactorAuthName$();
  }
  return $n_Lpresto_types$TwoFactorAuthName$;
}
export { $m_Lpresto_types$TwoFactorAuthName$ as $m_Lpresto_types$TwoFactorAuthName$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Name$.js.map
